// @flow

import * as React from 'react';
import styled from 'styled-components';

const InLineContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`;

type Props = {
  children?: React.Node,
};

export const InLine = ({ children }: Props) => (
  <InLineContainer>{children}</InLineContainer>
);
